<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/KnowledgeIndex/kManageEdit/kTypeList' }"
          >知识付费内容类型管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>知识付费内容类型设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>知识付费内容类型设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="form_item">
            <div class="block">
              <p><span class="mark">*</span>类型名称</p>
              <div class="textarea_box">
                <el-input
                  v-model="formData.typename"
                  placeholder="请输入类型名称"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>类型内容</p>
              <div class="textarea_box">
                <el-input
                  type="textarea"
                  v-model="formData.typecont"
                  placeholder="请输入类型内容"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>是否启用</p>
              <div class="radio_box">
                <el-radio-group v-model="formData.isuse">
                  <el-radio label="是">是</el-radio>
                  <el-radio label="否">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import {
  getKonwledgeTypeDetail,
  editKonwledgeType,
  addKonwledgeType,
} from "../../../api/knowledge";
export default {
  name: "kVideoDetail",
  data() {
    return {
      formData: {
        id: "",
        qyguid: "",
        qyname: "",
        typename: "",
        typecont: '',
        isuse: '',
        createuser: '',
      },

      loading: false,
      loadingText: "请稍后",
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.qyguid = USERINFO.qy.qyguid
    this.formData.qyname = USERINFO.qy.qyname
    this.formData.createuser = USERINFO.truename
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        if (id) {
          this.getDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    getDetail(id) {
      this.loading = true;
      getKonwledgeTypeDetail({ id }).then((res) => {
        this.formData.typename = res.typename ? res.typename : "";
        this.formData.typecont = res.typecont ? res.typecont : "";
        this.formData.isuse = res.isuse ? res.isuse : "";

        this.loading = false;
      });
    },

    handleReturn() {
      history.back();
    },

    query() {
      let { formData } = this;
       console.log(formData, "====-=formData=====");
      if (formData.qyname == "") {
        this.$message.warning("请输入类型名称");
        return;
      }
      if (formData.typecont == "") {
        this.$message.warning("请输入类型内容");
        return;
      }
      if (formData.isuse == "") {
        this.$message.warning("请选择是否启用");
        return;
      }
      this.loading = true;
      if (formData.id) {
        editKonwledgeType(formData).then((res) => {
          if (res.result) {
            this.loading = false;
            this.$message.success(res.message);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addKonwledgeType(formData).then((res) => {
          if (res.result) {
            this.loading = false;
            this.$message.success(res.message);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        .form_item {
          margin-bottom: 40px;
          .block {
            margin-bottom: 25px;
          }
        }
      }
    }
  }
  .product_details_edit {
    width: 100%;
    padding: 0 0 70px;
    font-size: 20px;
    color: #505050;
    .product_details_content {
      box-sizing: border-box;
      margin-bottom: 20px;
      .product_details_item {
        .product_details_item_operate {
          width: 100%;
          height: 50px;
          border: 1px solid #d2d2d2;
          font-size: 14px;
          padding: 0 22px;
          box-sizing: border-box;
          .txt {
            font-size: 16px;
          }
          .operate_group {
            .btn {
              border: 1px solid #d2d2d2;
              height: 25px;
              padding: 0 14px;
              margin-left: 20px;
              cursor: pointer;
              &.disable {
                color: #c1c1c1;
              }
            }
          }
        }
        .product_details_item_content {
          padding: 0 12px 40px;
          .txt_box {
            min-height: 150px;
            .van-cell {
              padding: 0;
            }
          }
          .pic_box,
          .video_box {
            padding-top: 25px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
    .product_details_operate {
      border: 1px solid #d2d2d2;
      padding: 15px 20px 20px;
      .txt {
        font-size: 16px;
        white-space: nowrap;
      }
      .btn {
        font-size: 14px;
        color: #ffffff;
        height: 30px;
        background: #1e1e1e;
        padding: 0 6px;
        white-space: nowrap;
        cursor: pointer;
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
    }
  }
  .popup_add_wrap {
    font-size: 18px;
    .popup_add_content {
      .add_item {
        cursor: pointer;
        height: 70px;
        border-bottom: 2px solid #ededed;
        &:last-child {
          border-bottom: none;
        }
        .iconfont {
          font-size: 26px;
          margin-right: 10px;
        }
      }
    }
    .popup_add_cancle {
      height: 100px;
      border-top: 5px solid #ededed;
    }
  }
}
</style>